var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BaseSubSection', {
    attrs: {
      "id": _vm.section.key,
      "is-visible": _vm.isSectionVisible,
      "is-modified": _vm.isDataChanged,
      "section": _vm.section,
      "clientCanEdit": _vm.IS_CLIENT
    },
    on: {
      "onSectionSaveClick": _vm.save
    },
    scopedSlots: _vm._u([{
      key: "section",
      fn: function fn() {
        return [_c('v-card-text', {
          staticClass: "mt-4"
        }, [_c('div', {
          staticClass: "mb-5"
        }, [_c('v-progress-linear', {
          staticClass: "mb-3",
          attrs: {
            "value": _vm.addressHistoryProgress,
            "height": "25",
            "dark": "",
            "rounded": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn() {
              return [_c('strong', [_vm._v(_vm._s(parseInt(_vm.addressHistoryMonth, 10) - _vm.coveredMonths) + " months remain")])];
            },
            proxy: true
          }])
        }), _c('v-data-iterator', {
          key: _vm.addressHistory.length,
          attrs: {
            "items": _vm.addressHistory,
            "hide-default-footer": "",
            "no-data-text": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn() {
              return [_c('v-row', _vm._l(_vm.addressHistory, function (addressHistoryItem, addressHistoryIdx) {
                return _c('v-col', {
                  key: addressHistoryIdx,
                  attrs: {
                    "cols": "12",
                    "lg": "6"
                  }
                }, [_c('v-card', [_c('v-card-subtitle', [_vm._v(" #" + _vm._s(addressHistoryIdx + 1) + " ")]), _c('v-card-text', [_c('v-list', [_c('AddressHistoryComponent', {
                  attrs: {
                    "model": addressHistoryItem,
                    "address-history-idx": addressHistoryIdx
                  },
                  on: {
                    "onUpdateAddressHistory": _vm.updateAddressHistory
                  }
                })], 1)], 1), _c('v-card-actions', [_c('v-btn', {
                  attrs: {
                    "color": "red lighten-2",
                    "icon": "",
                    "disabled": _vm.FIELDS_DISABLED && !_vm.IS_CLIENT
                  },
                  on: {
                    "click": function click($event) {
                      $event.stopPropagation();
                      return _vm.showRemoveDialog(addressHistoryIdx);
                    }
                  }
                }, [_c('v-icon', [_vm._v("mdi-delete")])], 1)], 1)], 1)], 1);
              }), 1), _c('v-dialog', {
                attrs: {
                  "max-width": "290"
                },
                model: {
                  value: _vm.isShowRemoveDialog,
                  callback: function callback($$v) {
                    _vm.isShowRemoveDialog = $$v;
                  },
                  expression: "isShowRemoveDialog"
                }
              }, [_c('v-card', [_c('v-card-title', {
                staticClass: "text-h5"
              }, [_vm._v(" Delete confirmation ")]), _c('v-card-text', [_vm._v(" Are you sure? ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
                attrs: {
                  "color": "gray darken-1",
                  "text": ""
                },
                on: {
                  "click": _vm.closeRemoveDialog
                }
              }, [_vm._v(" Cancel ")]), _c('v-btn', {
                attrs: {
                  "color": "red darken-1",
                  "text": ""
                },
                on: {
                  "click": _vm.removeAddressHistory
                }
              }, [_vm._v(" Delete ")])], 1)], 1)], 1)];
            },
            proxy: true
          }])
        }), _c('v-card-text', {
          staticClass: "mt-4"
        }, [_c('div', {
          staticClass: "mb-5 button-list"
        }, [_c('v-btn', {
          attrs: {
            "color": "primary",
            "disabled": _vm.FIELDS_DISABLED && !_vm.IS_CLIENT
          },
          on: {
            "click": _vm.copyDialogToggle
          }
        }, [_vm._v(" Copy from another applicant ")]), _c('v-btn', {
          attrs: {
            "color": "primary",
            "disabled": _vm.FIELDS_DISABLED && !_vm.IS_CLIENT
          },
          on: {
            "click": _vm.addAddressHistory
          }
        }, [_vm._v(" Add new ")])], 1)])], 1)]), _c('v-dialog', {
          attrs: {
            "width": "500"
          },
          model: {
            value: _vm.copyDialog,
            callback: function callback($$v) {
              _vm.copyDialog = $$v;
            },
            expression: "copyDialog"
          }
        }, [_c('v-card', [_c('v-card-title', {
          staticClass: "text-h5 grey lighten-2"
        }, [_vm._v(" Select the applicant to copy ")]), _c('v-divider'), _c('v-simple-table', {
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn() {
              return [_c('thead', [_c('tr', [_c('th', {
                staticClass: "text-left"
              }, [_vm._v(" Applicants ")])])]), _c('tbody', [_vm.applicantsExist ? _vm._l(_vm.applications, function (applicant, index) {
                return _c('tr', {
                  key: index
                }, [_c('td', {
                  staticClass: "table-row",
                  attrs: {
                    "id": "applicant-".concat(index)
                  },
                  on: {
                    "click": function click($event) {
                      return _vm.getApplicant(applicant, index);
                    }
                  }
                }, [_c('AddressHistoryApplicantName', {
                  attrs: {
                    "applicant": applicant
                  }
                })], 1)]);
              }) : _c('tr', [_c('td', [_vm._v("There are no applcants for copy now!")])])], 2)];
            },
            proxy: true
          }])
        }), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": ""
          },
          on: {
            "click": _vm.copyDialogToggle
          }
        }, [_vm._v(" Close Modal ")]), _vm.applicantsExist ? _c('v-btn', {
          attrs: {
            "color": "primary",
            "text": ""
          },
          on: {
            "click": _vm.copyApplicantHistory
          }
        }, [_vm._v(" Copy ")]) : _vm._e()], 1)], 1)], 1)];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }